var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUsHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#FF4E8D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 28.5H28M10 14.5V15.5C10 16.2956 10.3161 17.0587 10.8787 17.6213C11.4413 18.1839 12.2044 18.5 13 18.5C13.7956 18.5 14.5587 18.1839 15.1213 17.6213C15.6839 17.0587 16 16.2956 16 15.5M10 14.5H28M10 14.5L12 10.5H26L28 14.5M16 15.5V14.5M16 15.5C16 16.2956 16.3161 17.0587 16.8787 17.6213C17.4413 18.1839 18.2044 18.5 19 18.5C19.7956 18.5 20.5587 18.1839 21.1213 17.6213C21.6839 17.0587 22 16.2956 22 15.5M22 15.5V14.5M22 15.5C22 16.2956 22.3161 17.0587 22.8787 17.6213C23.4413 18.1839 24.2044 18.5 25 18.5C25.7956 18.5 26.5587 18.1839 27.1213 17.6213C27.6839 17.0587 28 16.2956 28 15.5V14.5M12 28.5V18.35M26 28.5V18.35M16 28.5V24.5C16 23.9696 16.2107 23.4609 16.5858 23.0858C16.9609 22.7107 17.4696 22.5 18 22.5H20C20.5304 22.5 21.0391 22.7107 21.4142 23.0858C21.7893 23.4609 22 23.9696 22 24.5V28.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsHomeIcon);
export default __webpack_public_path__ + "static/media/contact-us-home-icon.cdd8c6158c8f0bd59bfad770b94f4644.svg";
export { ForwardRef as ReactComponent };